import 'twin.macro';
import { exerciseType as exerciseTypes } from '../../constants/constants';
import TimerIcon from '../../assets/svgs/plank-timer.svg';
import tw from 'twin.macro';

// `hideIcon` drops the stopwatch glyph but keeps this pill's own scale — the
// TIMED_REPS design shows the countdown as time alone. `compact` is the rest
// screen's larger, icon-less variant and is unrelated.
const CutDownTimer = ({ timer, exerciseType, compact = false, hideIcon = false }) => {
  // Parse the timer string (e.g., "MM:SS") to calculate total seconds
  const [minutes, seconds] = timer.split(':').map(Number);
  const totalSeconds = minutes * 60 + seconds;

  // The last ten seconds turn red only where the clock is what ends the set —
  // on REP_BASED the set ends on the rep count, so a red countdown would read
  // as a deadline that isn't one.
  const dynamicBackgroundColor =
    exerciseType !== exerciseTypes.repBased && totalSeconds < 10
      ? 'rgba(255, 0, 0, 0.5)'
      : 'rgba(24, 24, 24, 0.5)';

  return (
    <div
      tw="py-[5px] flex items-center gap-4 px-[20px] rounded-[10px] text-white [font-family: Roboto, sans-serif]"
      css={compact && tw`w-fit gap-0 px-[18px] py-[6px]`}
      style={{ background: dynamicBackgroundColor }}
      data-testid="timer"
    >
      {/* shrink-0 + explicit box: the icon has no intrinsic width cap, so the
          flex row was shrinking it whenever the timer string grew a digit. */}
      {!compact && !hideIcon && (
        <img
          loading="lazy"
          decoding="async"
          src={TimerIcon}
          alt="Timer icon"
          width={31}
          height={31}
          tw="h-[31px] w-[31px] shrink-0"
        />
      )}
      <p
        tw="min-w-[5ch] text-center text-[40px] font-bold text-white! tabular-nums"
        css={compact && tw`text-[48px]`}
      >
        {timer}
      </p>
    </div>
  );
};

export default CutDownTimer;
